import { useCallback, useState } from "react";

import { useDragAndDrop } from "./useDragAndDrop";
import { useFileValidation } from "./useFileValidation";
import { useResumeUpload } from "./useResumeUpload";

export const useResumeUploader = ({ onPrepareUpload, onUploadSuccess }) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const { isFileInvalid, isFileTooLarge, validateFile, clearValidation } =
    useFileValidation();

  const { isUploading, uploadError, handleUpload, clearUploadError } =
    useResumeUpload({
      onPrepareUpload,
      onUploadSuccess,
    });

  const {
    isDragOver,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleFileInput,
  } = useDragAndDrop({
    onFileSelect: setSelectedFile,
    validateFile,
    clearValidation,
    clearUploadError,
  });

  const removeSelectedFile = useCallback(() => {
    setSelectedFile(null);
    clearValidation();
    clearUploadError();
  }, [clearUploadError, clearValidation]);

  const handleUploadClick = useCallback(() => {
    if (selectedFile && !isFileInvalid && !isFileTooLarge) {
      handleUpload(selectedFile);
    }
  }, [handleUpload, isFileInvalid, isFileTooLarge, selectedFile]);

  return {
    selectedFile,
    isDragOver,
    isUploading,
    isFileInvalid,
    isFileTooLarge,
    uploadError,
    removeSelectedFile,
    handleUploadClick,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleFileInput,
  };
};
